import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight, X, Camera } from 'lucide-react';
import { ProductReview } from '../../types';

interface CustomerMediaCarouselProps {
    reviews: ProductReview[];
}

export const CustomerMediaCarousel: React.FC<CustomerMediaCarouselProps> = ({ reviews }) => {
    const [selectedImage, setSelectedImage] = useState<string | null>(null);

    // Extract all media from approved reviews
    const allMedia = reviews.flatMap(r => r.media || []);

    if (allMedia.length === 0) return null;

    return (
        <div className="space-y-4 mt-8">
            <h4 className="text-xs font-mono font-bold uppercase tracking-widest text-zinc-500 flex items-center gap-2">
                <Camera size={14} /> Fotos de Clientes
            </h4>
            
            <div className="flex gap-2 overflow-x-auto pb-4 custom-scrollbar snap-x">
                {allMedia.map((media) => (
                    <button
                        key={media.id}
                        onClick={() => setSelectedImage(media.media_url)}
                        className="relative w-32 h-32 md:w-40 md:h-40 shrink-0 rounded-sm overflow-hidden border border-zinc-800 snap-start hover:border-zinc-500 transition-colors group"
                    >
                        <img 
                            src={media.media_url} 
                            alt="Foto de cliente" 
                            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        />
                        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors" />
                    </button>
                ))}
            </div>

            {/* Lightbox */}
            <AnimatePresence>
                {selectedImage && (
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        className="fixed inset-0 z-[110] flex items-center justify-center bg-black/95 backdrop-blur-xl p-4"
                        onClick={() => setSelectedImage(null)}
                    >
                        <button 
                            className="absolute top-6 right-6 p-2 bg-white/10 hover:bg-white/20 text-white rounded-full transition-colors z-10"
                            onClick={(e) => { e.stopPropagation(); setSelectedImage(null); }}
                        >
                            <X size={24} />
                        </button>
                        
                        <motion.img
                            initial={{ scale: 0.9, opacity: 0 }}
                            animate={{ scale: 1, opacity: 1 }}
                            exit={{ scale: 0.9, opacity: 0 }}
                            transition={{ type: "spring", damping: 25, stiffness: 300 }}
                            src={selectedImage}
                            alt="Vista ampliada"
                            className="max-w-full max-h-[90vh] object-contain shadow-2xl rounded-sm"
                            onClick={(e) => e.stopPropagation()}
                        />
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};
